(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kodo-cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  class KodoCartRecommendations extends HTMLElement {
    #revision = 0;
    #request;

    connectedCallback() {
      document.addEventListener('shopify:cart:lines-update', this.#onCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:cart:lines-update', this.#onCartUpdate);
      this.#revision++;
      this.#request?.abort();
    }

    #onCartUpdate = async (event) => {
      const revision = ++this.#revision;
      this.#request?.abort();
      this.hidden = true;
      try {
        // The native event starts before the cart mutation finishes.
        if (event.promise) await event.promise;
        if (revision !== this.#revision || !this.isConnected) return;
        this.#request = new AbortController();
        const url = new URL(this.dataset.cartUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.#request.signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Cart recommendations unavailable');
        const html = await response.text();
        if (revision !== this.#revision || !this.isConnected) return;
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('kodo-cart-recommendations');
        if (!next) return;
        this.replaceChildren(...next.childNodes);
        this.hidden = next.hidden;
      } catch (error) {
        // Optional recommendations must never block checkout or leave stale suggestions visible.
        if (error.name !== 'AbortError') console.warn('[kodo-cart-recommendations]', error);
      }
    };
  }

  if (!customElements.get('kodo-cart-recommendations')) {
    customElements.define('kodo-cart-recommendations', KodoCartRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kodo-universal-subcategory"] && !Shopify.designMode) return;
  try {
    
  const mobileBreakpoint = window.matchMedia('(max-width: 749px)');
  const categoryDisclosures = document.querySelectorAll('.kodo-category__disclosure');

  const syncCategoryDisclosures = () => {
    categoryDisclosures.forEach((disclosure) => {
      if (mobileBreakpoint.matches) {
        disclosure.setAttribute('name', disclosure.dataset.accordionName);
        disclosure.open = false;
      } else {
        disclosure.removeAttribute('name');
        disclosure.open = true;
      }
    });
  };

  syncCategoryDisclosures();
  mobileBreakpoint.addEventListener('change', syncCategoryDisclosures);

  categoryDisclosures.forEach((disclosure) => {
    disclosure.addEventListener('toggle', () => {
      if (!mobileBreakpoint.matches && !disclosure.open) {
        disclosure.open = true;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
